import React from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import { AllLocationsContext } from "repository/stores/dashboard/locations/locations-all-provider";

// Actions
// import { deleteLocation } from "repository/actions/data/dashboard/locations";

export default withSnackbar(
  withRouter(function (props) {
    const { isOpen, setClose, itemId, user, deleteLocation, setRefreshAlgolia } = props;
    const {location, setLocations} = React.useContext(AllLocationsContext);
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteLocation = () => {
      if (user && user != null) {
        setSaveLoading(true);

        deleteLocation(itemId, user.idToken)
          .then((result) => {
            setTimeout(() => { setRefreshAlgolia(true) }, 2000)
            setTimeout(() => { setRefreshAlgolia(false) }, 2000)
            toast.success(`Location successfully deleted`);
            setClose();
            setSaveLoading(false);
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Delete selected location"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteLocation()}
        actionButtonTitle="Yes, I'm sure"
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to delete this location?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
